module.exports = __webpack_public_path__ + "img/mirror16.c1ab89e5.jpg";